import React, { Component } from "react"
import SearchBox from "./common/searchBox"
import * as dataProvider from "../helpers/dataProvider"
import SearchResult from "./common/searchResult"
import OutsideClickTrigger from "../../booking/components/common/OutsideClickTrigger"
import unorm from "unorm"

class Typeahead extends Component {
  static defaultProps = {
    siteprefix: "",
    formTextModifier: "",
    useOriginalMarkup: true,
  }

  state = {
    query: "",
    data: {},
    timeout: undefined,
  }

  getDataConfig() {
    const dataConfig = {
      language: "da",
      shopSearchUrl: "/shop/soeg",
      siteSearchUrl: "/sogeresultater",
      shopLogo:
        "https://cph-prod-cdn.azureedge.net/490001/globalassets/6.-webshop/1.-forside/top-rr-deck/taxfree_brandmark_01_heinemann_rgb_small.png",
      isShop: true,
      texts: {
        brands: { categoryText: "I Mærker" },
        arrivals: { searchResultText: 'Se {{count}} ankomster med "{{searchQuery}}" i dag' },
        departures: { searchResultText: 'Se {{count}} afgange med "{{searchQuery}}" i dag' },
        footer: { defaultText: 'Se alt der starter med "{{searchQuery}}"' },
      },
      zeroState: {
        searchDefaultText: "Søg om...",
        defaultText: "Gå til søgeside",
        data: {
          ProductsTypeahead: [{ name: "Søg på Clinique", displayGroupName: "I Produkter", url: "https://www.cph.dk/shop/da-clinique" }],
          CategoryTypeahead: [{ name: "Søg på Hudpleje", displayGroupName: "I Kategorier", url: "https://www.cph.dk/shop/hudpleje" }],
          BrandsTypeahead: [{ name: "Søg på Biotherm", displayGroupName: "I Mærker", url: "https://www.cph.dk/shop/da-biotherm" }],
        },
      },
      sectionData: { mainTop: ["ProductsTypeahead"], mainBottom: [], asideTop: ["CategoryTypeahead"], asideBottom: ["BrandsTypeahead"] },
      noResults: {
        Shop: {
          noProducts: "Ingen produkter matchede din søgning",
          noCategory: "Ingen kategorier matchede din søgning.",
          noCategorySuggest: "Ingen kategorier matchede din søgning. Mente du {{suggestion}}",
          noShop: "Der kunne ikke findes nogle resultater i webshoppen.",
          noShopSuggest: "Der kunne ikke findes nogle resultater i webshoppen. Mente du {{suggestion}}",
          otherSearchResults: "Resultater fra resten af CPH",
        },
        default: {
          noFlights: "Ingen flyvninger matchede din søgning.",
          noFlightsSuggest: "Ingen flyvninger matchede din søgning. Mente du {{suggestion}}",
          noShop: "Intet fra webshoppen matchede din søgning",
        },
      },
    }
    return dataConfig
  }

  async handleSearch(query = "", track = true) {
    const data = await this.performSearch(query, track)
    this.setState({ query, data })
  }

  handleFocus(e) {
    this.props.activateSearch()
    this.handleSearch("", false)
  }

  handleRemoveSearch(e) {
    this.props.deactivateSearch()
    this.setState({ query: "", data: {} })
  }

  async performSearch(query, track = true) {
    const response = await dataProvider.getData(query)
    if (response && response.data) return dataProvider.createPageData(response.data, this.props.config, track, this.props.eventCategory, query)
    return dataProvider.createPageData({}, this.props.config, track, this.props.eventCategory, query)
  }

  checkQueryAgainstBrand(brand, query, urlSlug) {
    return query?.toLowerCase() === brand?.toLowerCase() ? urlSlug : null
  }

  toLowerCaseWithoutAccents(str) {
    if (str) {
      return unorm.nfd(str.toLowerCase()).replace(/[\u0300-\u036f]/g, "")
    }
    return null
  }

  render() {
    //const self = this
    const { query, data } = this.state
    const { filteredData, displayGroupNames } = data
    const dataConfig = this.props.config || this.getDataConfig()
    const hasBrands = filteredData?.BrandsTypeahead?.docs.length > 0
    let matchingBrand = undefined
    if (hasBrands) {
      let brand = filteredData.BrandsTypeahead.docs.find(
        (brand) => this.toLowerCaseWithoutAccents(this.state.query) === this.toLowerCaseWithoutAccents(brand.Name),
      )
      matchingBrand = brand && brand.UrlSlug
    }
    return (
      <React.Fragment>
        <OutsideClickTrigger onOutsideClick={(e) => this.handleRemoveSearch(e)}>
          <React.Fragment>
            <SearchBox
              searchUrl={dataConfig.shopSearchUrl}
              brand={matchingBrand}
              placeholderText={dataConfig.zeroState.searchDefaultText}
              onFocusHandler={this.handleFocus.bind(this)}
              onBlurHandler={this.handleRemoveSearch.bind(this)}
              handleSearch={this.handleSearch.bind(this)}
              useOriginalMarkup={this.props.useOriginalMarkup}
              formTextModifier={this.props.formTextModifier}
            ></SearchBox>
            {Object.keys(data).length > 0 && (
              <React.Fragment>
                <div
                  className={dataConfig.isShop ? "general-search-panel general-search-panel--taxfree is-active" : "general-search-panel is-active"}
                >
                  <div className="general-search-panel__inner">
                    <SearchResult
                      dataConfig={dataConfig}
                      searchQuery={query}
                      data={filteredData}
                      displayGroupNames={displayGroupNames}
                      eventCategory={this.props.eventCategory}
                    />
                  </div>
                </div>
              </React.Fragment>
            )}
          </React.Fragment>
        </OutsideClickTrigger>
      </React.Fragment>
    )
  }
}

export default Typeahead
